module.exports = __webpack_public_path__ + "img/ic_services_freewifi.17bda191.svg";